<div class="flex flex-col h-full overflow-hidden">
  <div>
    <h1>Filer</h1>
  </div>
  <div>
    <p-breadcrumb
      class="max-w-full cursor-pointer"
      styleClass="h-12"
      [model]="breadcrumbs()"
      [home]="home()"
      (onItemClick)="onBreadCrumbClick($event)">
      <ng-template #separator>\</ng-template>
    </p-breadcrumb>
  </div>
  <div class="flex gap-2 mb-4">
    <p-button
      label="Op"
      icon="pi pi-arrow-up"
      outlined
      [disabled]="breadcrumbs().length === 0"
      (click)="up()" />
    @if (uploadAllowed) {
      <p-fileupload
        mode="basic"
        name="files"
        [customUpload]="true"
        (uploadHandler)="uploadHandler($event)"
        chooseIcon="pi pi-upload"
        [url]="apiRoot + '/api/admin/serverfiler/upload'"
        maxFileSize="10000000"
        (onUpload)="onBasicUploadAuto()"
        [auto]="true"
        chooseLabel="Upload fil"
        class="let-fileupload-leftaligned" />
    }
  </div>
  <div class="flex-1 overflow-hidden" style="max-width: 1000px">
    <p-table
      [value]="tableData()"
      [loading]="data.isLoading()"
      [stripedRows]="true"
      [showGridlines]="true"
      [scrollable]="true"
      scrollHeight="flex"
      class="p-datatable-sm lp-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 20px"></th>
          <th pSortableColumn="filename">
            Navn <p-sortIcon field="filename" />
          </th>
          <th style="width: 160px" pSortableColumn="lastWriteTime">
            Sidst opdateret <p-sortIcon field="lastWriteTime" />
          </th>
          <th style="width: 110px" pSortableColumn="size">
            Størrelse <p-sortIcon field="size" />
          </th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="tableData()" pTemplate="body" let-item>
        <tr class="cursor-pointer" (click)="onRowClick(item)">
          <td>
            @if (item.isFolder) {
              <i class="pi pi-folder"></i>
            }
          </td>
          <td>
            {{ item.filename }}
            @if (!item.isFolder) {
              <i
                class="pi pi-download file-download"
                pTooltip="Download"
                (click)="onClickDowload($event, item)"></i>
              @if (allowDelete()) {
                <i
                  class="pi pi-times file-delete"
                  pTooltip="Slet fil"
                  (click)="onClickDelete($event, item)"></i>
              }
            }
          </td>
          <td class="numbers">
            {{ item.lastWriteTime | date: 'dd-MM-yyyy HH:mm:ss' }}
          </td>
          <td class="!text-end">
            @if (item.size) {
              {{ item.size || 0 | filesize }}
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirm-dialog />
